// Base features that are the same across countries
const BASE_FEATURES: Record<string, string> = {
  payroll: "Payroll for monthly schedules",
  nanny_portal: "Nanny portal to manage time off, expenses, etc",
  contract: "Free custom Employment Contract",
  invoices: "Instant professional invoicing for contractors",
  filings: "Automated tax filings",
  time_tracking: "Time tracking and scheduling",
  entity_setup: "Business entity setup assistance",
  business_registration: "Business registration support",
  documentation_support: "Documentation and compliance support",
  compliance_assistance: "Ongoing compliance assistance",
};

// UK-specific features
const UK_FEATURES: Record<string, string> = {
  register: "HMRC employer registration", // Only for employer plans, not contractor plans
  tax_queries: "Dealing with HMRC queries on your behalf", // Only for employer plans
  pension_management: "NEST pension plan management", // Only for employer plans
  self_assessment: "We'll file your Self Assessment for you (optional add‑on)",
  vat_guidance: "VAT guidance and support",
  ni_number_management: "National Insurance number management",
  companies_house_registration: "Companies House registration",
  hmrc_registration_support: "HMRC registration support",
  uk_tax_compliance: "UK tax compliance assistance",
};

// US-specific features
const US_FEATURES: Record<string, string> = {
  register: "IRS employer registration", // Only for employer plans, not contractor plans
  tax_queries: "Dealing with IRS queries on your behalf", // Only for employer plans
  pension_management: "401(k) and retirement plan management", // Only for employer plans
  tax_preparation_1040: "1040 tax preparation support",
  irs_support: "IRS registration support",
  w9_management: "W-9 form management",
  quarterly_tax_estimates: "Quarterly tax estimates",
  ein_application_assistance: "EIN application assistance",
  state_registration_guidance: "State registration guidance",
  irs_registration_support: "IRS registration support",
  tax_id_setup: "Tax ID setup assistance",
};

// Country-specific feature mappings
export const COUNTRY_FEATURES: Record<string, Record<string, string>> = {
  GB: { ...BASE_FEATURES, ...UK_FEATURES },
  US: { ...BASE_FEATURES, ...US_FEATURES },
};

// Default feature mapping (backwards compatibility)
export const FEATURE_TO_DISPLAY: Record<string, string> = COUNTRY_FEATURES.GB;

// Helper function to get features for a specific country
export const getFeatureDisplayText = (feature: string, countryCode: string = 'GB'): string => {
  return COUNTRY_FEATURES[countryCode]?.[feature] || FEATURE_TO_DISPLAY[feature] || feature;
};
